"use strict";

var $ = jQuery;

function saveScrollPosition() {
	var scrollPosition = window.scrollY || window.pageYOffset;
	sessionStorage.setItem("scrollPosition", scrollPosition); // Save to sessionStorage
}

// Function to restore the scroll position after page load
function restoreScrollPosition() {
	var scrollPosition = sessionStorage.getItem("scrollPosition");
	if (scrollPosition) {
		window.scrollTo(0, parseInt(scrollPosition, 10)); // Restore the scroll position
		sessionStorage.removeItem("scrollPosition"); // Clear after restoring
	}
}

function encodeToBase64(value) {
	return btoa(String(value)); // Convert to Base64
}

function showErrorAboveFilterTabs(message) {
	// Find the `.filter_tabs` container

	$(".filter_tabs").before(
		'<div class="custom-error-message" > <span class="custom-error-message-icon" >! </span>There was a problem with your submission. Please review the fields below</div>'
	);
}

// function getFilterData() {
//     var filters = {};

//     // Find all form inputs with names starting with 'filters['
//     $(".shuttle-filter-form")
//         .find("[name^='filters[']")
//         .each(function () {
//             // Get the name and value of the input
//             var name = $(this).attr("name");
//             var value = $(this).val();

//             // Remove 'filters[' prefix and ']' suffix from the name
//             var filterName = name.replace(/^filters\[(.+)\]$/, '$1');

//             // Add to the filters object
//             filters[filterName] = value;
//         });

//     return filters;
// }

function initShuttleFilterForm() {
	var $shuttleFilterForm = $(".shuttle-filter-form");

	// Check if the form exists
	if (!$shuttleFilterForm.length) {
		return;
	}

	// Add submit event listener to the form
	$shuttleFilterForm.on("submit", function (event) {
		event.preventDefault();

		// Clear previous error messages
		$(".margin-height").remove();
		$(".error-message").remove();
		$(".custom-error-message").remove();

		// var filters = getFilterData();

		// Get form input values
		var toLocation = $("#to_location").val();
		var fromLocation = $("#from_location").val();
		var hour = parseInt($("#hour_input").val(), 10);
		var minute = parseInt($("#minute_input").val(), 10);
		var date = $("#custom_date").val();
		var activeTab = $("#active_tab").val();
		var isValid = true;
		// // Validate 'To' location
		if (!toLocation && fromLocation) {
			$("#to_location")
				.closest(".shuttle-filter-column")
				.append(
					'<div class="error-message" >Please select a destination</div>'
				)
				.append(
					'<div class="margin-height" style="height:40px; visible:hidden" ></div>'
				);

			isValid = false;
		}

		if (!fromLocation && toLocation) {
			$("#from_location")
				.closest(".shuttle-filter-column")
				.append(
					'<div class="error-message" >Please select a departure location</div>'
				)
				.append(
					'<div class="margin-height" style="height:40px; visible:hidden" ></div>'
				);
			isValid = false;
		}
		// if (!toLocation) {
		// 	$("#to_location")
		// 		.closest(".shuttle_filter_tool_select_wrapper")
		// 		.append(
		// 			'<div class="error-message" style="position: absolute; font-size: 14px;">Please select a destination</div>'
		// 		);
		// 	isValid = false;
		// }

		// // Validate 'From' location
		// if (!fromLocation) {
		// 	$("#from_location")
		// 		.closest(".shuttle_filter_tool_select_wrapper")
		// 		.append(
		// 			'<div class="error-message" style="position: absolute; font-size: 14px;">Please select a departure location</div>'
		// 		);
		// 	isValid = false;
		// }

		// Validate 'Hour' (1 to 12)
		if (
			(!isNaN(minute) && isNaN(hour)) ||
			(!isNaN(hour) && (hour < 1 || hour > 12))
		) {
			$("#hour_input")
				.closest(".shuttle-filter-column")
				.append(
					'<div class="error-message" >Hour must be between 1 and 12</div>'
				)
				.append(
					'<div class="margin-height" style="height:20px; visible:hidden" ></div>'
				);
			isValid = false;
		}

		// Validate 'Minute' (0 to 59)
		if (
			(!isNaN(hour) && isNaN(minute)) ||
			(!isNaN(minute) && (minute < 0 || minute > 59))
		) {
			$("#minute_input")
				.closest(".shuttle-filter-column")
				.append(
					'<div class="error-message" >Minute must be between 0 and 59</div>'
				)
				.append(
					'<div class="margin-height" style="height:20px; visible:hidden" ></div>'
				);
			isValid = false;
		}
		// console.log("the date is here", date);
		if (date) {
			var selectedDate = new Date(date);
			if (selectedDate == "Invalid Date") {
				$("#custom_date")
					.closest(".shuttle-filter-column")
					.append(
						'<div class="error-message" >Please select a valid date</div>'
					)
					.append(
						'<div class="margin-height" style="height:20px; visible:hidden" ></div>'
					);
				isValid = false;
			} else {
				var selectedDay = selectedDate.getDay(); // 0 = Sunday, 6 = Saturday

				if (
					activeTab === "weekday" &&
					(selectedDay === 0 || selectedDay === 6)
				) {
					$("#custom_date")
						.closest(".shuttle-filter-column")
						.append(
							'<div class="error-message" >Please select a weekday</div>'
						)
						.append(
							'<div class="margin-height" style="height:20px; visible:hidden" ></div>'
						);
					isValid = false;
				} else if (
					activeTab === "weekend" &&
					selectedDay >= 1 &&
					selectedDay <= 5
				) {
					$("#custom_date")
						.closest(".shuttle-filter-column")
						.append(
							'<div class="error-message" >Please select a weekend date</div>'
						)
						.append(
							'<div class="margin-height" style="height:20px; visible:hidden" ></div>'
						);
					isValid = false;
				}
			}
		} else {
			if (activeTab === "weekday") {
				$("#custom_date")
					.closest(".shuttle-filter-column")
					.append(
						'<div class="error-message" >Please select a weekday</div>'
					)
					.append(
						'<div class="margin-height" style="height:20px; visible:hidden" ></div>'
					);
			} else {
				$("#custom_date")
					.closest(".shuttle-filter-column")
					.append(
						'<div class="error-message" >Please select a weekend</div>'
					)
					.append(
						'<div class="margin-height" style="height:20px; visible:hidden" ></div>'
					);
			}
			isValid = false;
		}

		if (!isValid) {
			showErrorAboveFilterTabs(
				"Please select a destination before proceeding."
			);
		}
		// If the form is valid, submit it
		else if (isValid) {
			// $("#hour_input").val(encodeToBase64(hour));
			// $("#minute_input").val(encodeToBase64(minute));
			saveScrollPosition();
			this.submit(); // Proceed with form submission
		}
	});

	var $swap_switch = $(".swap_icon");

	$swap_switch.on("click", function (event) {
		var toLocation = $("#to_location");
		var fromLocation = $("#from_location");

		if (toLocation.length && fromLocation.length) {
			// Swap the values
			event.preventDefault(); 
			var tempValue = toLocation.val();
			toLocation.val(fromLocation.val());
			fromLocation.val(tempValue);
		} else {
			console.warn(
				"Could not find '#to_location' or '#from_location' elements."
			);
		}
	});

	$swap_switch.on("keydown", function (event) {
		// Check for Enter (13) or Space (32) key
		if (event.key === "Enter" || event.key === " " || event.keyCode === 13 || event.keyCode === 32) {
			event.preventDefault(); // Prevent default action for Space
			$(this).trigger("click"); // Trigger click functionality
		}
	});

	$(".shuttle_schedule_container").on(
		"click",
		".shuttle_schedule_card",
		function () {
			// Cache the results of DOM lookups for performance
			var $card = $(this);
			var $content = $card.find(".shuttle-schedule-detail-content");
			var $icon = $card.find(".shuttle-schedule-plus-icon");

			$content.slideToggle(300);
			$icon.toggleClass("icon-active");
		}
	);
	$(".shuttle-schedule-plus-icon").on("keydown", function (event) {
		// Check for Enter (13) or Space (32) key
		if (
			event.key === "Enter" ||
			event.key === " " ||
			event.keyCode === 13 ||
			event.keyCode === 32
		) {
			event.preventDefault(); // Prevent default action for Space
			$(this).trigger("click"); // Trigger click functionality
		}
	});
}

// Initialize the Shuttle Filter Form handling
$(document).ready(function () {
	var $shuttlePage = $(".shuttle-filter-form"); // Replace with your specific page class or container
	var $activeTabElement = $("#active_tab")[0];
	var $activeTab = $activeTabElement ? $activeTabElement.value : null;
	if ($shuttlePage.length) {
		initShuttleFilterForm($shuttlePage); // Initialize form handling within the specific page container
		restoreScrollPosition(); // Restore scroll position after page load
		flatpickr("#custom_date", {
			dateFormat: "m/d/Y", // Set date format to MM/DD/YYYY
			allowInput: true, // Allow manual input if desired
			defaultDate:
				document.getElementById("custom_date").value || "today",
			enable: [
				function (date) {
					if ($activeTab == "weekend") {
						return date.getDay() === 0 || date.getDay() === 6;
					}
					// Enable only weekdays (Monday to Friday)
					return date.getDay() !== 0 && date.getDay() !== 6;
				},
			],
		});
	}
});
